import { SVGFC } from '@repo/toolkit/types'

const UserRemoveIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_17676_40893)">
        <path
          d="M10.7054 4.55469C8.66868 4.55469 7.00263 6.22193 7.00263 8.25868C7.00263 9.50406 7.62739 10.6069 8.57718 11.2779C6.36625 12.1642 4.79804 14.3266 4.79804 16.8491C4.78039 17.6444 5.98236 17.6444 5.96471 16.8491C5.96471 14.1716 8.1236 12.0139 10.8011 12.0139C11.7358 12.0139 12.6034 12.2803 13.3418 12.7373C14.0057 13.1444 14.6163 12.1487 13.9525 11.7416C13.62 11.5359 13.2598 11.3754 12.8884 11.2368C13.8052 10.5624 14.4048 9.4793 14.4048 8.25868C14.4048 6.22193 12.7422 4.55469 10.7054 4.55469ZM10.7054 5.72252C12.1117 5.72252 13.2381 6.85244 13.2381 8.25868C13.2381 9.66492 12.1117 10.7902 10.7054 10.7902C9.2992 10.7902 8.1693 9.66492 8.1693 8.25868C8.1693 6.85244 9.2992 5.72252 10.7054 5.72252ZM14.284 15.6483C15.0327 15.6483 15 15.6483 15.4507 15.6483H16.6185C17.3971 15.6483 17.3971 14.4805 16.6185 14.4805C16.6185 14.4805 15.9065 14.4663 15.4507 14.4805C15.2695 14.4862 15.5 14.4805 15 14.4805H14.284H13.0895C12.283 14.5178 12.3388 15.6855 13.1174 15.6483H14.284Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_17676_40893">
          <rect width="14" height="14" fill="white" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default UserRemoveIcon
